document.addEventListener('DOMContentLoaded', () => {
  const section = document.querySelector('.testimonials-slider');
  if (!section) return;

  const track = section.querySelector('[data-track]');
  const viewport = section.querySelector('[data-viewport]');
  const prevButton = section.querySelector('[data-prev]');
  const nextButton = section.querySelector('[data-next]');
  const cards = section.querySelectorAll('.testimonial-card');

  if (!track || !viewport || !cards.length) return;

  let currentIndex = 0;

  function getVisibleCount() {
    return window.innerWidth < 990 ? 1 : 3;
  }

  function getMaxIndex() {
    return Math.max(0, cards.length - getVisibleCount());
  }

  function updateSlider() {
    const cardWidth = cards[0].getBoundingClientRect().width;
    const gap = window.innerWidth < 990 ? 0 : 38;
    const offset = currentIndex * (cardWidth + gap);
    track.style.transform = `translateX(-${offset}px)`;
  }

  function goTo(index) {
    const maxIndex = getMaxIndex();
    currentIndex = Math.max(0, Math.min(index, maxIndex));
    updateSlider();
  }

  if (prevButton) {
    prevButton.addEventListener('click', () => {
      goTo(currentIndex - 1);
    });
  }

  if (nextButton) {
    nextButton.addEventListener('click', () => {
      goTo(currentIndex + 1);
    });
  }

  window.addEventListener('resize', () => {
    if (currentIndex > getMaxIndex()) {
      currentIndex = getMaxIndex();
    }
    updateSlider();
  });

  updateSlider();
});
